var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('v-row',{staticClass:"mb-6"},[_c('v-col',[_c('h1',[_vm._v("Settings")])])],1),_c('v-row',{attrs:{"no-gutters":""}},[_c('role-permissions')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }